import { createBridgeComponent } from '@module-federation/bridge-react/v19';
import App from './App';

export default createBridgeComponent({
  rootComponent: App,
});
